import ReactTable from "../Components/Table";
const Module1 = () => {
  const click_Handler = (column, row) => {
    alert();
  };
  const tableColumns = [
    {
      header: "Name",
      accessor: "name",
      sortable: true,
      isHyperLink: true,
      clickHandler: click_Handler,
    },
    { header: "Age", accessor: "age", sortable: true, alignment: "right" },
    { header: "Email", accessor: "email", sortable: true },
    {
      header: "Birth Date",
      accessor: "birthDate",
      dateType: true,
      sortable: true,
    },
    { header: "Custom Input", accessor: "customInput", isInput: true },
  ];

  const tableData = [
    {
      name: "John Doe",
      age: 30,
      email: "john@example.com",
      birthDate: "19-09-1998",
      comment: "s",
    },
    {
      name: "Jane Smith",
      age: 25,
      email: "jane@example.com",
      birthDate: "19-08-1997",
      comment: "s",
    },
    // Add more rows if needed...
  ];

  return <ReactTable data={tableData} columns={tableColumns} />;
};

export default Module1;
